
import { defineComponent } from 'vue';

export default defineComponent({
  emits: ['close', 'click'],
  props: {
    closable: {
      type: Boolean,
      default: false,
    },
    actived: {
      type: Boolean,
      default: false,
    },
  },
  setup() {},
});
